<div class="row pb-2 dense-1">
  <div class="col" [formGroup]="projectSettingsForm">
    <div class="row pb-1">
      <h6>
        Project ID: {{ project.proj_id }}
      </h6>
    </div>
    <div class="row">
      <div class="col-auto">
        <mat-checkbox formControlName="rbac" (change)="updatePermissions('rbac')">Project Access Control</mat-checkbox>
      </div>
      <div class="col-auto mt-1">
        <mat-icon matTooltip="Enable this to define which users can access the project. If disabled all users can access the project.">info_outline</mat-icon>
      </div>
    </div>
    <div class="row ps-4 pb-2">
      <div class="col-auto">
        <mat-checkbox formControlName="gbac" (change)="updatePermissions('gbac')">Activity Group Access Control</mat-checkbox>
      </div>
      <div class="col-auto mt-1">
        <mat-icon matTooltip="Enable this to define activity parameters specific management groups are allowed to see. In this way you can filter what activities specific groups see.">info_outline</mat-icon>
      </div>
    </div>
    <div class="row pb-1">
      <mat-form-field>
        <mat-label>Management Groups (comma separated, match Company Management list)</mat-label>
        <textarea matInput formControlName="managementGroups" (change)="updateManagementGroups()"></textarea>
      </mat-form-field>
    </div>
    <div class="row pb-1">
      <mat-form-field>
        <mat-label>Project Company</mat-label>
        <mat-select formControlName="projectLogo" (selectionChange)="updateCompanyLogo($event.value)">
          <mat-option [value]="undefined"></mat-option>
          @for (company of companyList; track $index) {
            <mat-option [value]="company.id">{{ company.display_name }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
    <div class="row pb-1">
      <mat-form-field>
        <mat-label>Update Frequency (days)</mat-label>
        <input matInput formControlName="updateFreq" type="number" (change)="updateFreqChange()">
      </mat-form-field>
    </div>
    <div class="row pb-1">
      <mat-form-field>
        <mat-label>Maximum Working Hours (person/day)</mat-label>
        <input matInput formControlName="maxHours" type="number" max="24" min="0" step="1" (change)="updateMaxHours()">
      </mat-form-field>
    </div>
    <div class="row">
      <mat-form-field>
        <mat-label>Project Contact Emails (comma seperated)</mat-label>
        <textarea matInput formControlName="kpaContactEmail" type="text" (change)="updateContact()"></textarea>
      </mat-form-field>
    </div>
  </div>
  <div class="col">
    @for (ext of projExtensions | keyvalue: originalOrder; track ext.key) {
      @if (ext.value.allowed) {
        <mat-card appearance="outlined" class="mb-1">
          <mat-card-content>
            <div class="row gx-0">
              <div class="col-auto gx-0 my-auto mx-auto pe-3">
                <mat-checkbox [(ngModel)]="ext.value.enabled" (change)="updateExtensions()"></mat-checkbox>
              </div>
              <div class="col gx-0">
                <mat-card-title>
                  <mat-icon aria-hidden="false" aria-label="Extension icon" [fontIcon]="ext.value.icon" class="icon-center"></mat-icon>
                  {{ ext.value.name }}
                </mat-card-title>
                <div class="pt-1">
                  {{ ext.value.description }}
                </div>
                @if (ext.value.hasOptions) {
                  <mat-expansion-panel class="mt-2">
                    <mat-expansion-panel-header>
                      <mat-panel-title>Extension Options</mat-panel-title>
                    </mat-expansion-panel-header>
                    <div class="col g-0">
                      @for (subOpt of ext.value.options | keyvalue; track subOpt.key) {
                        <div class="row g-0">
                          <div class="col-auto g-0 dense-6 pe-2">
                            <mat-checkbox [(ngModel)]="subOpt.value.enabled" (change)="updateExtensions()">{{subOpt.value.name}}</mat-checkbox>
                          </div>
                        </div>
                      }
                    </div>
                  </mat-expansion-panel>
                }
              </div>
            </div>
          </mat-card-content>
        </mat-card>
      }
    }
  </div>
</div>
<div class="row pb-2">
  <div class="col text-center normal-button-density">
    <button matButton="elevated" class="mat-ctrlkey-orange" (click)="selectNewProjectId()">Change Project ID</button>
  </div>
</div>